import html2canvas from "html2canvas";
import { saveAs } from "file-saver";

export const getScreenshot = (componentId, name) => {
  const postComponent: any = document.getElementById(componentId);

  html2canvas(postComponent, {
    allowTaint: true,
    scale: 4,
    useCORS: true,
    backgroundColor: "#f2f2f2",
    scrollX: 0,
    scrollY: -window.scrollY,
  }).then(async (canvas) => {
    canvas.toBlob((blob) => {
      saveAs(blob, `${name}.png`);
    });
  });
};

export const getScreenshotV2 = async (componentId, name) => {
  const postComponent: any = document.getElementById(componentId);

  const canvas = await html2canvas(postComponent, {
    allowTaint: true,
    scale: 2,
    useCORS: true,
    backgroundColor: "#f2f2f2",
    scrollX: 0,
    scrollY: -window.scrollY,
    logging: false,
  });
  const blob = await new Promise((resolve, reject) =>
    canvas.toBlob((blob) =>
      blob ? resolve(blob) : reject(new Error("Error creating blob"))
    )
  );
  saveAs(blob, `${name}.png`);
};
